import { render, staticRenderFns } from "./Depreciation.vue?vue&type=template&id=0c9db15b"
import script from "./Depreciation.vue?vue&type=script&lang=js"
export * from "./Depreciation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports